import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import locations, { LocationState } from './modules/locations';
import speakers, { Speaker } from './modules/speakers';
import network, { Network } from './modules/network';
import device, { Device } from './modules/device';
import policy, { Policy } from './modules/policy';
import user, { User } from './modules/user';

export interface StoreState {
  locations: LocationState,
  speakers: Speaker[],
  network: Network,
  device: Device,
  policy: Policy,
  user: User

}

Vue.use(Vuex);

export default new Vuex.Store<StoreState>({
  plugins: [createPersistedState()],
  modules: {
    network,
    device,
    policy,
    user
  },
  strict: process.env.NODE_ENV !== 'production'
});
